import { Injectable } from '@angular/core';

import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
  NavigationExtras,
  CanLoad,
  Route,
} from '@angular/router';

import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class RedirectGuardService implements CanActivate, CanActivateChild, CanLoad {
  environment;
  constructor(private router: Router) {
    this.environment = environment;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const url = state.url;

    return this.checkRedirect(url, route);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  canLoad(route: Route): boolean {
    const url = '/${route.path}';

    return this.checkRedirect(url);
  }

  checkRedirect(url: string, route?): boolean {
    if (this.environment && this.environment.links) {
      window.location.replace(this.environment.links.brandHome);
    }

    return false;
  }
}
